module.exports = __webpack_public_path__ + "img/shipping.a4704a8a.png";